<div class="jumbotron text-center">
  <h1 class="display-4">¡Gracias por participar de la votación!</h1>
  <br>
  <br>
  <br>
  <br>

  <button mat-raised-button color="primary" type="button" (click)="finalizar()" >Cerrar</button>
  <br>
  <br>
  <br>
  <p>{{nombreFondo}}</p>
</div>
